import ENV from 'env.json';

export const API = {
    general: {
        sendCode: ENV.api + '/General/SendOtp',
        verifyPwOrOtp: ENV.api + '/General/VerifyPwOrOtp',
        setNewPassword: ENV.api + '/General/SetNewPassword',
        forgotPassword: ENV.api + '/General/ForgotPassword',
        verifyForgetPassword: ENV.api + '/General/VerifyForgetPassword',
        twoFaQrCode: ENV.api + '/General/TwoFaQrCode',
        setup2Fa: ENV.api + '/General/Setup2Fa',
        disable2Fa: ENV.api + '/General/Disable2Fa',
        profile: ENV.api + '/General/Profile',
        editPhoneNumber: ENV.api + '/General/EditPhoneNumber',
        verifyNewPhoneNumber: ENV.api + '/General/VerifyNewPhoneNumber',
        signInVerify2Fa: ENV.api + '/General/SignInVerify2Fa',
    },
    enum: {
        orderStates: ENV.api + '/Enum/OrderStates',
        orderSides: ENV.api + '/Enum/OrderSides',
        transactionTypes: ENV.api + '/Enum/TransactionTypes',
        transactionStates: ENV.api + '/Enum/TransactionStates',
        marketTypes: ENV.api + '/Enum/MarketTypes',
        orderTransactionStates: ENV.api + '/Enum/OrderTransactionStates',
        orderTransactionTypes: ENV.api + '/Enum/OrderTransactionTypes',
        notificationReasons: ENV.api + '/Enum/NotificationReasons',
        ticketStates: ENV.api + '/Enum/TicketStates',
    },
    fiat: {
        all: ENV.api + '/Fiat/GetAllFiats',
    },
    market: {
        index: ENV.api + '/Market',
        prices: (page: number, pageSize: number) => `${API.market.index}/Prices/${page}/${pageSize}`,
        all: (page: number, pageSize: number) => `${API.market.index}/All/${page}/${pageSize}`,
        pricesBySymbol: (coin: string) => `${API.market.index}/PricesBySymbol/${coin?.toUpperCase()}`,
        networks: (symbol: string, isDeposit: boolean) =>
            `${API.market.index}/Networks/${symbol?.toUpperCase()}/${isDeposit}`,
        depositNetworks: (coin: string) => `${API.market.index}/DepositNetworks/${coin?.toUpperCase()}`,
        validate: (sourceMarket: string, destinationMarket: string, sourceAmount: string, destinationAmount: string) =>
            `${API.market.index}/Validate/${sourceMarket}/${destinationMarket}/${sourceAmount}/${destinationAmount}`,
    },
    notification: {
        getMine: (page: number, pageSize: number) => ENV.api + `/Notification/GetMine/${page}/${pageSize}`,
        read: ENV.api + '/Notification/Read',
    },
    order: {
        mine: ENV.api + '/Order/get-mine',
    },
    orderTransaction: {
        getMine: ENV.api + '/OrderTransaction/GetMine',
        buyCrypto: ENV.api + '/OrderTransaction/BuyCrypto',
        buyUUSD: ENV.api + '/OrderTransaction/BuyUUSD',
        sellCrypto: ENV.api + '/OrderTransaction/SellCrypto',
        sellUUSD: ENV.api + '/OrderTransaction/SellUUSD',
        buyOrderTransaction: ENV.api + '/OrderTransaction/BuyOrderTransaction',
        setTxId: ENV.api + '/OrderTransaction/SetTxId',
        searchTxId: ENV.api + '/OrderTransaction/SearchTxId',
        getByTrackingCode: (trackingCode: string) => `${ENV.api}/OrderTransaction/GetByTrackingCode/${trackingCode}`,
        verifyBuy: ENV.api + '/OrderTransaction/VerifyBuy',
        buyPayeer: ENV.api + '/OrderTransaction/BuyPayeer',
    },
    referral: {
        getMineReferralInfo: ENV.api + '/Referral/GetMineReferralInfo',
        getMineReferralActions: (page: number, pageSize: number) =>
            ENV.api + `/Referral/GetMineReferralActions/${page}/${pageSize}`,
        getMineInvitedUsers: (page: number, pageSize: number) =>
            ENV.api + `/Referral/GetMineInvitedUsers/${page}/${pageSize}`,
        requestWithdrawal: ENV.api + '/Referral/RequestWithdrawal',
    },
    ticket: {
        add: ENV.api + '/Ticket/Add',
        answer: ENV.api + '/Ticket/Answer',
        get: (id: string) => ENV.api + `/Ticket/Get/${id}`,
        mine: (page: number, pageSize: number) => ENV.api + `/Ticket/Mine/${page}/${pageSize}`,
    },
    transaction: {
        mine: ENV.api + '/Transaction/mine',
        cashInRequest: ENV.api + '/Transaction/CashInRequest',
        cardToCardSettings: ENV.api + '/Transaction/GetCardToCardSettings',
        offlineDepositSettings: ENV.api + '/Transaction/GetOfflineDepositSettings',
        deposit: ENV.api + '/Transaction/Deposit/Currency/Pay',
        currencyWithdrawal: ENV.api + '/Transaction/Withdrawal/Currency/Request',
        verifyCurrencyWithdrawal: ENV.api + '/Transaction/Withdrawal/Currency/Verify',
        verifyCurrencyDeposit: ENV.api + '/Transaction/deposit/currency/verify',
        getByTrackingCode: (trackingCode: string) => `${ENV.api}/Transaction/crypto-details/${trackingCode}`,
    },
    wallet: {
        mine: ENV.api + '/Wallet/Mine',
        sync: ENV.api + '/Wallet/mine/sync',
    },
    bankAccount: {
        cardNumber: ENV.api + '/BankAccount/GetMineCardNumbers',
        iBan: ENV.api + '/BankAccount/GetMineIBanNumbers',
        addCardNumber: ENV.api + '/BankAccount/AddCardNumber',
        addIBanNumber: ENV.api + '/BankAccount/AddIBanNumber',
        removeCardNumber: (id: string) => `${ENV.api}/BankAccount/RemoveCardNumber/${id}`,
        removeIBanNumber: (id: string) => `${ENV.api}/BankAccount/RemoveIBanNumber/${id}`,
    },
    level: {
        mine: ENV.api + '/Level/Mine',
        requestUpgradeTo1: ENV.api + '/Level/Request-Upgrade-To-1',
        verifyUpgradeTo1: ENV.api + '/Level/Verify-Upgrade-To-1',
        requestUpgradeTo2: ENV.api + '/Level/Request-Upgrade-To-2',
        verifyUpgradeTo2: ENV.api + '/Level/Verify-Upgrade-To-2',
        uploadFilesUpgradeTo2: ENV.api + '/Level/UploadFiles-Upgrade-To-2',
    },
    siteSettings: {
        currency: ENV.api + '/SiteSettings/currency',
        cardToCardSettingActivation: ENV.api + '/SiteSettings/CardToCardSettingActivation',
        offlineDepositActivation: ENV.api + '/SiteSettings/OfflineDepositActivation',
        cashInActivation: ENV.api + '/Admin/SiteSettings/CashInActivation',
        commissions: ENV.api + '/SiteSettings/commissions',
        gatewaySettingsActivation: ENV.api + '/SiteSettings/GatewaySettingsActivation',
    },
};
